import React from 'react';
import { copyFor } from 'config';
import { Crate, FlexCrate } from '@perch-labs/shrike';
import {
  SecondaryBadge,
  StyledListItem,
  StyledContainer,
  StyledHeading,
  StyledSupportingText,
  StyledText,
  StyledTooltipContainer,
} from '../line-items.style';
import { ArrowIcon } from '../arrow-icon';

const getCopy = copyFor('billing.statement.lineItems.vnmSolarChargePreCredit');

export const VnmSolarChargePreCreditLineItem: React.FunctionComponent<{
  utilityName?: string;
}> = ({ utilityName }) => {
  return (
    <StyledListItem data-testid="vnm-solar-charge-line-item">
      <StyledContainer>
        <FlexCrate flexDirection="column" gap="8px">
          <StyledTooltipContainer>
            <StyledHeading color="secondary">{getCopy('title')}</StyledHeading>
          </StyledTooltipContainer>
          <Crate padding="0 64px 0 0">
            <StyledSupportingText color="secondary">
              {getCopy('subtitle', { utilityName })}
            </StyledSupportingText>
          </Crate>
        </FlexCrate>

        <SecondaryBadge margin={{ right: '-8px' }} size="small">
          {getCopy('badges.comingSoon')}
        </SecondaryBadge>
      </StyledContainer>

      <FlexCrate
        flexDirection="column"
        margin={{ top: '16px' }}
        gap="16px"
        width="100%"
      >
        <StyledContainer>
          <FlexCrate flexDirection="column" gap="8px">
            <StyledTooltipContainer>
              <StyledText color="secondary">
                {' '}
                <ArrowIcon />
                <b>{getCopy('savings.title')}</b>
              </StyledText>
            </StyledTooltipContainer>
            <Crate padding="0 64px 0 32px">
              <StyledSupportingText color="secondary">
                {getCopy('savings.subtitle')}
              </StyledSupportingText>
            </Crate>
          </FlexCrate>
        </StyledContainer>

        <StyledContainer>
          <FlexCrate flexDirection="column" gap="8px">
            <StyledTooltipContainer>
              <StyledText color="secondary">
                {' '}
                <ArrowIcon />
                <b>{getCopy('subtotal.title')}</b>
              </StyledText>
            </StyledTooltipContainer>
            <Crate padding="0 64px 0 32px">
              <StyledSupportingText color="secondary">
                {getCopy('subtotal.subtitle', { utilityName })}
              </StyledSupportingText>
            </Crate>
          </FlexCrate>
        </StyledContainer>
      </FlexCrate>
    </StyledListItem>
  );
};
